import { useState, useEffect } from 'react';
import { getBACNumberFromJWT } from '@raisin/cp-utils';

export const useBacNumber = () => {
  const [bacNumber, setBacNumber] = useState<string | null>(null);

  useEffect(() => {
    try {
      const fetchedBacNumber = getBACNumberFromJWT();
      setBacNumber(fetchedBacNumber);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching bacNumber:', error);
      setBacNumber(null);
    }
  }, []);

  return bacNumber;
};
